import { Avatar, Container, Grid, Tab, TabList, TabPanel, TabPanels, Tabs, Text, VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import bg from "../../../assets/course.webp";
import Layout from "../../../components/student/Layout/layout";
import { getAllSectionsRequest } from "../../../modules/students-modules/sections/Actions";
import StudyWithEnoughExams from "../studyWithEnough/exams-list";

const SectionsList = () => {
  const sections = useSelector((state) => state.sections.sections);
  const isLoading = useSelector((state) => state.sections.isLoading);
  const { id, type } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) dispatch(getAllSectionsRequest(id));
  }, [id]);

  const sectionsGrid = (
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(4, 1fr)" }}
            gap={6}
            w="100%"
          >
            {sections?.map((section, idx) => {
              return (
                <Link to={`/section/${section?.id}/chapters/${type}`} key={idx}>
                  <VStack
                    bg="#ededed"
                    borderRadius="8px"
                    alignItems="center"
                    justifyContent="center"
                    p="10px"
                    spacing="20px"
                    w="100%"
                    cursor="pointer"
                    h="200px"
                    role="group"
                    _hover={{
                      color: "white",
                      bg: "main_1",
                      transition: "500ms ease-in-out",
                    }}
                  >
                    <Avatar
                      name={section?.name}
                      src={bg}
                      borderRadius="8px"
                      size="md"
                      background="transparent"
                      _groupHover={{
                        transform: "scale(1.5)",
                        transition: "500ms ease-in-out",
                      }}
                    />

                    <Text
                      fontWeight="700"
                      fontSize="16px"
                      w="250px"
                      textAlign="center"
                    >
                      {section?.name}
                    </Text>
                    <Text
                      fontWeight="700"
                      fontSize="12px"
                      color="gray.500"
                      w="250px"
                      textAlign="center"
                    >
                      {section?.chapters?.length} Lessons
                    </Text>
                  </VStack>
                </Link>
              );
            })}
          </Grid>
  );

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.xl" h="100%" my="150px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start">
          {type === "homework" ? (
            <Tabs variant="enclosed" color="main_1" w="100%" isLazy>
              <TabList>
                <Tab>Homework</Tab>
                <Tab>Study your homework with agwad</Tab>
              </TabList>
              <TabPanels>
                <TabPanel px={0} pt={6}>
                  {sectionsGrid}
                </TabPanel>
                <TabPanel px={0} pt={6}>
                  <StudyWithEnoughExams
                    courseId={id}
                    hwFlag={1}
                    embedded
                    hideVideos
                    title="Study your homework with agwad"
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          ) : (
            sectionsGrid
          )}
        </VStack>
      </Container>
    </Layout>
  );
};

export default SectionsList;
